<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M23.116 6.123l-5.246-5.242c-0.542-0.543-1.29-0.879-2.117-0.881h-12.753c-1.656 0.006-2.997 1.348-3 3.005v25.995c0 1.657 1.343 3 3 3v0h17.995c1.657 0 3-1.343 3-3v0-20.752c-0.001-0.829-0.337-1.58-0.879-2.124l0 0zM21.704 7.542c0.125 0.123 0.217 0.28 0.262 0.455l0.001 0.007h-5.971v-5.968c0.182 0.046 0.339 0.138 0.462 0.263l0 0zM20.999 30.001h-17.999c-0.552-0.001-1-0.448-1.001-1v-25.995c0.001-0.552 0.448-1 1-1.001h11.005v6.5c0 0.001 0 0.002 0 0.003 0 0.827 0.67 1.497 1.497 1.497 0.001 0 0.002 0 0.004 0h6.498v18.996c-0.001 0.553-0.449 1.001-1.002 1.001-0.002 0-0.004 0-0.005 0h0zM17.997 14.754v0.506c-0.002 0.413-0.336 0.747-0.749 0.749h-10.499c-0.413-0.002-0.747-0.336-0.749-0.749v-0.506c0.002-0.413 0.336-0.747 0.749-0.749h10.499c0.413 0.002 0.747 0.336 0.749 0.749v0zM17.997 18.753v0.506c-0.002 0.413-0.336 0.747-0.749 0.749h-10.499c-0.413-0.002-0.747-0.336-0.749-0.749v-0.506c0.001-0.414 0.336-0.749 0.749-0.751h10.499c0.414 0.002 0.748 0.337 0.749 0.751v0zM17.997 22.752v0.506c-0.002 0.413-0.336 0.747-0.749 0.749h-10.499c-0.413-0.002-0.747-0.336-0.749-0.749v-0.506c0.001-0.414 0.336-0.749 0.749-0.751h10.499c0.414 0.002 0.748 0.337 0.749 0.751v0z" />
    </g>

  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
